// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 519 ? "maplibre" : chunkId) + "-" + {"172":"febe521cffbb7ed85173","519":"2935c88fd1c4b2ca56a3"}[chunkId] + ".chunk.js";
};